import { memo } from 'react'

import CulturesCard from '@/components/elements/cards/culturesCard'
import HeaderOverhaul from '@/components/elements/headerOverhaul'

const OurCulture = ({ data }) => {
  const { header, cultures } = data

  return (
    <div className="our-culture-wrapper">
      <HeaderOverhaul header={header} subtitle />
      <div className="our-culture-custom-grid grid-wrapper grid-columns-2-1">
        <CulturesCard cards={cultures} />
      </div>
    </div>
  )
}

export default memo(OurCulture)
